import { NewFacture3Input } from "compta-shared";
import { FactureState } from "../hooks/useFacture";
const factureStateToFacture = (factureState: FactureState) => {
  if (!factureState.mode) {
    throw new Error("factureState.mode is null in factureStateToFacture");
  }
  const chequeNumber =
    factureState.mode === "Chèque1"
      ? (factureState.chequeNumber || "").trim() || null
      : null;
  return {
    modeRef: factureState.modeRef,
    ...(chequeNumber ? { chequeNumber } : {}),
    mode: factureState.mode,
    date: factureState.date || null,
    datePrelevement: factureState.datePrelevement || null,
    libellé: factureState.libellé,
    montantCent: factureState.montantCent,
    compte: factureState.compte || null,
    règlements: règlementsStateToRèglements(factureState.règlements),

    ventilations: ventilationsStateToVentilations(factureState.ventilations),
    docId: factureState.docId,
    validationDate: factureState.validationDate || null,
    banqueId: factureState.banqueId || null,
  } satisfies NewFacture3Input;
};

const règlementsStateToRèglements = (
  règlements: FactureState["règlements"],
) => {
  return règlements
    .filter((r) => !r.isPlaceholder)
    .filter((r) => !!r.date)
    .map((r) => {
      return {
        date: r.date!,
        montantCent: r.montantCent,

        ventilations: ventilationsStateToVentilations(r.ventilations),
        banqueId: r.banqueId,
      };
    });
};

const ventilationsStateToVentilations = (
  ventilations: FactureState["ventilations"],
) => {
  return ventilations.map((v) => {
    return {
      compte: v.compte,
      montantCent: v.montantCent,
      pourcentageCent: v.pourcentageCent,
    };
  });
};

export default factureStateToFacture;
